import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";

const ToggleFooter = () => {
  const location = useLocation();

  const [showFooter, setShowFooter] = useState(true);

  useEffect(() => {
    if (
      location.pathname.startsWith("/admin") ||
      location.pathname.startsWith("/login") ||
      location.pathname.startsWith("/signup") ||
      location.pathname.startsWith("/activate") ||
      location.pathname.startsWith("/reset") ||
      location.pathname.startsWith("/password/reset")
    ) {
      setShowFooter(false);
    } else {
      setShowFooter(true);
    }
  }, [location]);

  return showFooter && <Footer />;
};

export default ToggleFooter;
